/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Tag_Filter_LabelInputs */



/**
* | output |
* | --- |
* | "Filter by tag:" |
*
* @param {Projects_Tag_Filter_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_tag_filter_label = /** @type {((inputs?: Projects_Tag_Filter_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Tag_Filter_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach Tag filtern:")
	return /** @type {LocalizedString} */ ("Filter by tag:")
});